import React, { memo } from 'react';
import { Button, Space, Tag } from 'antd';
import '../../styles/responsive-cards.css';

const MobileCard = memo(({ title, fields, actions, tag }) => {
  return (
    <div className="mobile-card">
      <div className="mobile-card-header">
        <h3 className="mobile-card-title">{title}</h3>
        {tag && <div className="mobile-card-tag">{tag}</div>}
      </div>
      <div className="mobile-card-body">
        {fields.map((field, index) => (
          <div className="mobile-card-field" key={index}>
            <span className="mobile-card-label">{field.label}:</span>
            <span className="mobile-card-value">{field.value}</span>
          </div>
        ))}
      </div>
      {actions && actions.length > 0 && (
        <div className="mobile-card-actions">
          {actions.map((action, index) => (
            <Button
              key={index}
              type={action.type || 'default'}
              icon={action.icon}
              onClick={action.onClick}
              size={action.size || 'middle'}
              danger={action.danger}
              block={action.block}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
});

export default MobileCard;
